import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import WhenToUse from './components/WhenToUse';
import Services from './components/Services';
import Benefits from './components/Benefits';
import WhyChooseUs from './components/WhyChooseUs';
import GettingStarted from './components/GettingStarted';
// @ts-ignore
import sectionItemService from '../../services/sectionItemService';
// @ts-ignore
import { useAutoSEO } from '../../hooks/useSEOFromRoute';

const PAGE_SLUG = 'security-assessment-code-review';

export default function SecurityAssessmentServicePage() {
  // Auto fetch SEO from database based on route
  useAutoSEO();

  const [sectionItems, setSectionItems] = useState<{
    businessChallenges?: any[];
    whyChoose?: any[];
    benefits?: any[];
    services?: any[];
  }>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSectionItems = async () => {
      try {
        setLoading(true);
        const response = await sectionItemService.getServicePage(PAGE_SLUG);
        if (response?.success && response.data) {
          setSectionItems(response.data);
        } else {
          setSectionItems({});
        }
      } catch (error) {
        console.error('Error fetching section items:', error);
        setSectionItems({});
      } finally {
        setLoading(false);
      }
    };

    fetchSectionItems();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <WhenToUse items={sectionItems.businessChallenges || []} loading={loading} />
      <Services items={sectionItems.services || []} loading={loading} />
      <Benefits items={sectionItems.benefits || []} loading={loading} />
      <WhyChooseUs items={sectionItems.whyChoose || []} loading={loading} />
      <GettingStarted />
    </div>
  );
}
